import { render } from "./Check.vue?vue&type=template&id=0cb89e1e"
const script = {}

import exportComponent from "/var/www/ab-front-library/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__